export default __webpack_public_path__ + "static/media/1.92e37e41.svg";